<script>
  import { onDestroy } from 'svelte';
  import { lang } from '../lib/stores';
  export let chapter = 10;
  export let title = '';
  export let subtitle = '';
  export let color = 2;
  let selectedLang;
  const unsubscribe = lang.subscribe((value) => selectedLang = value);
	onDestroy(unsubscribe);
</script>

<section class="title color-{color}">
  <div class="title__container">
    {#if chapter > 0}<h2>{#if selectedLang === 'it'}Capitolo{:else}Chapter{/if} <span>{chapter}</span></h2>{/if}
    <h1>{title}</h1>
    {#if subtitle != ''}<h3>{subtitle}</h3>{/if}
  </div>
</section>

<style>
  .title {
    align-content: center;
    align-items: center;
    background: var(--background);
    display: flex;
    height: 50vh;
    justify-content: center;
    position: sticky;
    text-align: center;
    text-transform: uppercase;
    top: 0;
    width: 100%;
    z-index: -1;
  }

  .title.color-1 {
    background: var(--accent-1);
  }

  .title.color-2 {
    background: var(--accent-2);
  }

  .title.color-3 {
    background: var(--accent-3);
  }

  .title__container {
    display: block;
    flex: 0 0 90vw;
    transform: rotate(12deg);
  }

  .title.color-1 .title__container {
    transform: rotate(6deg);
  }

  .title.color-2 .title__container {
    transform: rotate(-6deg);
  }

  .title.color-3 .title__container {
    transform: rotate(-9deg);
  }

  .title h3,
  .title h2,
  .title h1 {
    font-size: 1rem;
    line-height: .9;
    margin: 1rem 0;
  }
  .title h2 {
    color: var(--foreground);
    text-shadow: none;
  }

  .title h3 {
    font-size: .8rem;
    margin: 0 auto;
    max-width: 40vw;
  }

  .title h1 {
    font-size: 1.8rem;
  }

@media screen and (min-width: 768px) {
  .title h1 {
    font-size: 3rem;
  }

  .title h2 {
    font-size: 1.8rem;
  }

  .title h3 {
    font-size: 1rem;
  }
}

@media screen and (min-width: 1024px) {
  .title h1 {
    font-size: 3.5rem;
  }

  .title h2 {
    font-size: 2.6rem;
  }

  .title h3 {
    font-size: 1.2rem;
  }
}

@media screen and (min-width: 1260px) {
  .title h1 {
    font-size: 4.6rem;
  }

  .title h2 {
    font-size: 2.8rem;
  }

  .title h3 {
    font-size: 1.6rem;
  }
}
</style>